import { useState, useEffect, useRef } from "react";

function getPersistentStorageValue(key, defaultValue) {

  if (typeof window !== "undefined") {
    const source = localStorage.getItem(key);
    const storedData = source !== null && source !== "undefined" ? JSON.parse(source) : defaultValue;
    return storedData;
  }
}

function isQuotaExceededError(err) {
  return (
    err instanceof DOMException &&
    // everything except Firefox
    (err.code === 22 ||
      // Firefox
      err.code === 1014 ||
      err.name === "QuotaExceededError" ||
      // Firefox
      err.name === "NS_ERROR_DOM_QUOTA_REACHED")
  );
}

export const usePersistentStorage = (key, defaultValue) => {
  const isInitialMount = useRef(true);
  const [value, setValue] = useState(() => {
    return getPersistentStorageValue(key, defaultValue);
  });

  useEffect(() => {

    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      if (typeof (Storage) !== "undefined") {
        try {
          localStorage.setItem(key, JSON.stringify(value));
        } catch (err) {
          if (isQuotaExceededError(err)) {
            console.log("Localstorage Quota Exceeded:" + err);
            let errMsg = {
              key: 'QuotaExceededError',
              msg: err
            }
            localStorage.setItem(key, JSON.stringify(errMsg));
          }
        }

      } else {
        console.log("Localstorage is not supported!!!");
      }
    }
  }, [key, value]);

  return [value, setValue];
};

export const clearPersistentStorage = () => {
  if (typeof window !== "undefined") {
    localStorage.clear();
  }
}